import polylabel from 'polylabel'
import connectDatastoreClient from '@/lib/connect-client/connect-datastore-client'
import connectNaviClient from '@/lib/connect-client/connect-navi-client'
import * as Constants from '@/lib/constants'
import * as FieldImport from '@/lib/field-import'
import Geo from '@/lib/geo'
import router from '@/router'
import store from '../index'
import TaskPolygons from '@/lib/task/task-polygons'
import Toast from '@/lib/toast'
import { emitFeedEvent } from '@/lib/feed-events'
import * as Types from '../mutation-types'
import i18n from '../../lib/i18n'
import UserInfo from '@/lib/user-info'
import ApplicationConfig from '@/lib/application-config'

const turf = require('@turf/turf')

// state,getters,mutationsはnavi.js
const state = {}
const getters = {}
const mutations = {}

const actions = {
  /***************************
   * FieldItems
   ***************************/
  /**
   *
   */
  initFields2({ commit }, opts) {
    commit(Types.CLEANUP_CURRENT_FILED)
    const params = {
      pageOptions: store.getters.pagingOptions.fields,
      sortOptions: store.getters.sortOptions.fields,
    }

    // UserInfoがない場合は、ログインしていないので、何もしない
    if (!UserInfo.get()) {
      return
    }

    if (UserInfo.isFSMigrated()) {
      connectDatastoreClient
        .getFields2ForPage(params)
        .then(response => {
          const apiResponse = {
            response: response,
            opts: opts,
          }
          store.dispatch('afterInitFields2', apiResponse)
        })
        .catch(error => {
          console.error(error)
        })
    } else {
      connectNaviClient
        .getFields2ForPage(params)
        .then(response => {
          const apiResponse = {
            response: response,
            opts: opts,
          }
          store.dispatch('afterInitFields2', apiResponse)
        })
        .catch(error => {
          console.error(error)
        })
    }
  },
  afterInitFields2({ commit }, apiResponse) {
    const response = apiResponse.response
    const opts = apiResponse.opts

    const paginationInfoAndType = {
      type: Constants.FIELDS_PAGINATION_INFO_TYPE,
      info: response.data.paginationInfo,
    }
    commit(Types.SET_PAGINATION_INFO, paginationInfoAndType)
    const fields = response.data.contents
    if (fields.length === 0) {
      if (opts) {
        if (opts.fieldEmptyAction === Constants.INIT_FIELD_OPTION_SHOW_FIELD_IMPORT) {
          // store.dispatch('setListViewMode', { view: 'field', mode: Constants.LIST_VIEW_MODE_APPEND })
          // router.push({ name: 'FieldList' })
          router.push({
            name: 'FieldListAsList',
          })
        }
      }
      const path = location.pathname
      const pathArray = path.split('/')
      if (pathArray[1] !== 'enterprise') {
        // 同期を促すメッセージの表示を廃止 https://github.com/agri-info-design/connect-servers/issues/1112
        // Toast.i18nError('customErrorInitFieldsNoFields')
      }
    }
    commit(Types.LIST_FILEDS_SUCCESS, fields)

    // 昨付も取得
    store.dispatch('initPlantings')
  },

  getAllFields({ commit }, opts) {
    commit(Types.CLEANUP_CURRENT_FILED)
    if (UserInfo.isFSMigrated()) {
      connectDatastoreClient
        .getFields2()
        .then(response => {
          const apiResponse = {
            response: response,
            opts: opts,
          }
          store.dispatch('afterGetAllFields', apiResponse)
        })
        .catch(error => {
          console.error(error)
        })
    } else {
      connectNaviClient
        .getFields2()
        .then(response => {
          const apiResponse = {
            response: response,
            opts: opts,
          }
          store.dispatch('afterGetAllFields', apiResponse)
        })
        .catch(error => {
          console.error(error)
        })
    }
  },
  afterGetAllFields({ commit }, apiResponse) {
    const response = apiResponse.response
    const opts = apiResponse.opts

    const fields = response.data
    if (fields.length === 0) {
      if (opts) {
        if (opts.fieldEmptyAction === Constants.INIT_FIELD_OPTION_SHOW_FIELD_IMPORT) {
          router.push({ name: 'FieldListAsList' })
        }
      }
      // 同期を促すメッセージの表示を廃止 https://github.com/agri-info-design/connect-servers/issues/1112
      // Toast.i18nError('customErrorInitFieldsNoFields')
    }
    commit(Types.LIST_FILEDS_SUCCESS, fields)

    if (opts) {
      if (opts.taskDetailShowAction === Constants.SHOW_TASK_DETAIL_FROM_DIRECT) {
        store.dispatch('showTaskDetailFromDirect', opts)
        return
      }
      opts.onSuccess()
    }
  },

  countTasksInField({ commit }, field) {
    if (UserInfo.isFSMigrated()) {
      connectDatastoreClient.countTasksForField(field).then(response => {
        const apiResponse = {
          response: {
            data: response.data.taskCount,
          },
        }
        store.dispatch('afterCountTasksInField', apiResponse)
      })
    } else {
      connectNaviClient.countTasksForField(field).then(response => {
        const apiResponse = {
          response: response,
        }
        store.dispatch('afterCountTasksInField', apiResponse)
      })
    }
  },
  afterCountTasksInField({ commit }, apiResponse) {
    const response = apiResponse.response
    const count = response.data
    commit(Types.SET_COUNT_TASKS_IN_CURRENT_FIELD, count)
  },

  getCentroidOfUserFields({ commit }) {
    if (UserInfo.isFSMigrated()) {
      connectDatastoreClient
        .getCentroidOfUserFields()
        .then(response => {
          const apiResponse = {
            response: response,
          }
          store.dispatch('afterGetCentroidOfUserFields', apiResponse)
        })
        .catch(error => {
          // 圃場そのものが見つからない場合、デフォルトエリア
          store.dispatch('initGrowCrops', { lat: 0, lon: 0 })
        })
    } else {
      connectNaviClient
        .getCentroidOfUserFields()
        .then(response => {
          const apiResponse = {
            response: response,
          }
          store.dispatch('afterGetCentroidOfUserFields', apiResponse)
        })
        .catch(error => {
          // 圃場そのものが見つからない場合、デフォルトエリア
          store.dispatch('initGrowCrops', { lat: 0, lon: 0 })
        })
    }
  },
  afterGetCentroidOfUserFields({ commit }, apiResponse) {
    const response = apiResponse.response
    const point = response.data
    if (point) {
      commit(Types.SET_CENTROID_OF_USER_FIELDS, point)
      // FIXME Grow
      const coord = turf.getCoord(point)
      store.dispatch('initGrowCrops', { lat: coord[0], lon: coord[1] })
    } else {
      // 圃場中心がない、という結果がサーバーから返された場合、デフォルトエリア
      store.dispatch('initGrowCrops', { lat: 0, lon: 0 })
    }
  },
  updateFieldMetaData({ commit }, updateRequest) {
    if (UserInfo.isFSMigrated()) {
      connectDatastoreClient
        .updateFieldMetaData(updateRequest)
        .then(response => {
          const params = {
            response: response,
            id: updateRequest.field.id,
            syncedAt: updateRequest.field.syncedAt,
            updateRequest: updateRequest,
            nextFunction: 'afterUpdateFieldMetaData',
          }
          store.dispatch('waitSyncAsUpdateField', params)
        })
        .catch(error => {
          console.error(error)
          params.onFailure()
        })
    } else {
      connectNaviClient
        .updateFieldMetaData(updateRequest)
        .then(response => {
          const apiResponse = {
            response: response,
            updateRequest: updateRequest,
          }
          store.dispatch('afterUpdateFieldMetaData', apiResponse)
        })
        .catch(error => {
          console.error(error)
          params.onFailure()
        })
    }
  },
  afterUpdateFieldMetaData({ commit }, apiResponse) {
    const response = apiResponse.response
    const updateRequest = apiResponse.updateRequest
    const updatedField = response.data
    commit(Types.SET_CURRENT_FIELD, updatedField)
    updateRequest.onSuccess()
  },

  updateFieldPolygon({ commit }, updateRequest) {
    if (UserInfo.isFSMigrated()) {
      connectDatastoreClient
        .updateFieldPolygon(updateRequest)
        .then(response => {
          const params = {
            response: response,
            id: updateRequest.field.id,
            syncedAt: updateRequest.field.syncedAt,
            updateRequest: updateRequest,
            nextFunction: 'afterUpdateFieldPolygon',
          }
          store.dispatch('waitSyncAsUpdateField', params)
        })
        .catch(error => {
          request.onFailure()
          console.error()
        })
    } else {
      connectNaviClient
        .updateFieldPolygon(updateRequest)
        .then(response => {
          const apiResponse = {
            response: response,
            updateRequest: updateRequest,
          }
          store.dispatch('afterUpdateFieldPolygon', apiResponse)
        })
        .catch(error => {
          request.onFailure()
          console.error()
        })
    }
  },
  afterUpdateFieldPolygon({ commit }, apiResponse) {
    const response = apiResponse.response
    const updateRequest = apiResponse.updateRequest
    const field = response.data
    commit(Types.SET_CURRENT_FIELD, field)
    updateRequest.onSuccess(field)
  },

  checkCountTaskForField({ commit }, params) {
    const field = params.field
    if (UserInfo.isFSMigrated()) {
      connectDatastoreClient
        .countTasksForField(field)
        .then(response => {
          const apiResponse = {
            response: response,
            params: params,
          }
          store.dispatch('afterCheckCountTaskForField', apiResponse)
        })
        .catch(error => {
          console.error(error)
          params.onFailure()
        })
    } else {
      connectNaviClient
        .countTasksForField(field)
        .then(response => {
          const apiResponse = {
            response: response,
            params: params,
          }
          store.dispatch('afterCheckCountTaskForField', apiResponse)
        })
        .catch(error => {
          console.error(error)
          params.onFailure()
        })
    }
  },
  afterCheckCountTaskForField({ commit }, apiResponse) {
    const response = apiResponse.response
    const params = apiResponse.params
    params.onSuccess(response)
  },

  deleteField({ commit }, updateRequest) {
    const field = updateRequest.field
    if (UserInfo.isFSMigrated()) {
      connectDatastoreClient.deleteField(field).then(response => {
        const request = {
          id: updateRequest.field.id,
          syncedAt: updateRequest.field.syncedAt,
          onSuccess: updateRequest.onSuccess,
          onFailure: updateRequest.onFailure,
          updateRequest: updateRequest,
          nextFunction: 'afterDeleteField',
        }
        store.dispatch('waitSyncAsUpdateField', request)
      })
    } else {
      connectNaviClient.deleteField(field).then(response => {
        const apiResponse = {
          updateRequest: updateRequest,
        }
        store.dispatch('afterDeleteField', apiResponse)
      })
    }
  },
  afterDeleteField({ commit }, apiResponse) {
    const updateRequest = apiResponse.updateRequest
    store.dispatch('initFields2')
    updateRequest.onSuccess()
  },

  waitSyncAsUpdateField({ commit }, params) {
    const request = {
      id: params.id,
      syncedAt: params.syncedAt,
      onSuccess: params.updateRequest.onSuccess,
      onFailure: params.updateRequest.onFailure,
    }
    let apiCallCount = 0
    let intervalId = setInterval(function() {
      connectDatastoreClient
        .waitSyncAsUpdateFieldMetaData(request)
        .then(response => {
          if (response.data.isCompleted) {
            clearInterval(intervalId)

            const apiResponse = {
              response: { data: response.data.remoteFieldItem },
              updateRequest: params.updateRequest,
            }
            store.dispatch(params.nextFunction, apiResponse)
          }
        })
        .catch(error => {
          console.error(error)
          params.updateRequest.onFailure()
          clearInterval(intervalId)
        })
      apiCallCount++
      if (apiCallCount > Constants.SYNC_WAIT_LIMIT_COUNT) {
        console.error('WaitSyncAsUpdateField API Call Limit!!')
        params.updateRequest.onFailure()
        clearInterval(intervalId)
      }
    }, Constants.SYNC_WAIT_API_CALL_INTERVAL)
  },

  createField({ commit }, params) {
    if (UserInfo.isFSMigrated()) {
      connectDatastoreClient
        .importFields(params.request)
        .then(response => {
          const results = (response.data && response.data.importResults) || []
          const apiResponse = {
            params: params,
            createdIds: results.filter(rs => rs.success).map(rs => rs.id),
          }
          store.dispatch('afterCreateField', apiResponse)
        })
        .catch(error => {
          console.error(error)
          Toast.i18nError('customFieldCreateWithMapCreateErrorMessage', {
            fieldName: params.fieldName,
          })
        })
    } else {
      connectNaviClient
        .importFields(params.request)
        .then(response => {
          const apiResponse = {
            params: params,
          }
          store.dispatch('afterCreateField', apiResponse)
        })
        .catch(error => {
          console.error(error)
          Toast.i18nError('customFieldCreateWithMapCreateErrorMessage', {
            fieldName: params.fieldName,
          })
        })
    }
  },
  afterCreateField({ commit }, apiResponse) {
    const params = apiResponse.params || {}
    const feature = params.request && params.request.features && params.request.features[0]
    emitFeedEvent('field_added', params.fieldName, undefined, feature && feature.geometry)
    router.push({
      name: 'FieldListAsList',
    })
    store.dispatch('setListViewMode', {
      view: 'field',
      mode: Constants.LIST_VIEW_MODE_LIST,
    })
    Toast.i18nSuccess('customFieldCreateWithMapCreateFinishedMessage', {
      fieldName: params.fieldName,
    })
    // 作成はバックエンド同期が非同期なので、一覧に現れるまで再取得を繰り返す
    store.dispatch('reloadFieldsUntilSynced', { fieldName: params.fieldName, ids: apiResponse.createdIds })
  },

  // 圃場一覧を再取得する。ids (作成された圃場の id) 指定時はそれが現れるか全件数が増えるまで、
  // fieldName 指定時はその圃場が現れるまで、未指定時は件数が増えるまで繰り返す (見つからなければ諦める)。
  // 同期 (Firestore→RDB) はコールドスタートで 10 秒を超えることがあるため、
  // 間隔を延ばしながら合計 ~60 秒まで粘る
  reloadFieldsUntilSynced({ commit }, params) {
    const totalOf = function() {
      const info = store.getters.paginationInfos.fields || {}
      return typeof info.totalElements === 'number' ? info.totalElements : null
    }
    const initialTotal = totalOf()
    const initialCount = (store.getters.fields || []).length
    const expected = params.expectedCount || 1
    const isSynced = function() {
      const fields = store.getters.fields || []
      if (params.ids && params.ids.length > 0) {
        // 表示中のページに現れた (単一作成で最も確実)
        if (params.ids.some(id => fields.some(f => f.id === id))) {
          return true
        }
        // ソート順によっては別ページに入るので、全件数の増加でも同期完了とみなす
        const total = totalOf()
        return initialTotal !== null && total !== null && total >= initialTotal + expected
      }
      if (params.fieldName) {
        return fields.some(f => f.name === params.fieldName)
      }
      return fields.length > initialCount
    }

    let attempt = 0
    const scheduleNext = function() {
      if (attempt >= Constants.SYNC_RELOAD_DELAYS_SEC.length) {
        return
      }
      const delaySec = Constants.SYNC_RELOAD_DELAYS_SEC[attempt]
      attempt++
      setTimeout(function() {
        if (isSynced()) {
          return
        }
        store.dispatch('initFields2')
        scheduleNext()
      }, delaySec * 1000)
    }
    store.dispatch('initFields2')
    scheduleNext()
  },

  importFields({ commit }, request) {
    if (UserInfo.isFSMigrated()) {
      connectDatastoreClient
        .importFields(request)
        .then(response => {
// TEMP           console.log(response.data.importResults)
          const succeeded = response.data.importResults.filter(rs => rs.success)
          const apiResponse = {
            count: succeeded.length,
            failedCount: response.data.importResults.filter(rs => !rs.success).length,
            createdIds: succeeded.map(rs => rs.id),
          }
          store.dispatch('afterImportFields', apiResponse)
        })
        .catch(error => {
          console.error(error)
          Toast.i18nError('customFieldImportErrorMessage')
        })
    } else {
      connectNaviClient
        .importFields(request)
        .then(response => {
          const apiResponse = {
            count: response.data.count,
          }
          store.dispatch('afterImportFields', apiResponse)
        })
        .catch(error => {
          console.error(error)
          Toast.i18nError('customFieldImportErrorMessage')
        })
    }
  },
  afterImportFields({ commit }, apiResponse) {
    if (apiResponse.count > 0) {
      emitFeedEvent('field_added', 'Import x' + apiResponse.count)
    }
    store.dispatch('setListViewMode', {
      view: 'field',
      mode: Constants.LIST_VIEW_MODE_LIST,
    })
    Toast.i18nSuccess('customFieldImportFinishedMessage', {
      count: apiResponse.count,
    })
    // インポートも同期が非同期なので、件数が増えるまで再取得を繰り返す
    store.dispatch('reloadFieldsUntilSynced', {
      ids: apiResponse.createdIds,
      expectedCount: apiResponse.count,
    })
  },

  /***************************
   * TaskRecordItem
   ***************************/
  initTasksWithFilter({ commit }, opts) {
    let pagingOptions = opts.pagingOptions
    if (!pagingOptions) {
      pagingOptions = store.getters.pagingOptions.tasks
    }
    let filter = opts.taskFilter

    if (UserInfo.isFSMigrated()) {
      connectDatastoreClient
        .getTasksWithFilter(filter, pagingOptions)
        .then(response => {
          const apiResponse = {
            response: response,
            filter: filter,
            opts: opts,
          }
          store.dispatch('afterInitTasksWithFilter', apiResponse)
        })
        .catch(error => {
          console.error(error)
          opts.onFinally()
        })
    } else {
      connectNaviClient
        .getTasksWithFilter(filter, pagingOptions)
        .then(response => {
          const apiResponse = {
            response: response,
            filter: filter,
            opts: opts,
          }
          store.dispatch('afterInitTasksWithFilter', apiResponse)
        })
        .catch(error => {
          console.error(error)
          opts.onFinally()
        })
    }
  },
  afterInitTasksWithFilter({ commit }, apiResponse) {
    const response = apiResponse.response
    const filter = apiResponse.filter
    const opts = apiResponse.opts
    const paginationInfoAndType = {
      type: Constants.TASKS_PAGINATION_INFO_TYPE,
      info: response.data.paginationInfo,
    }
    commit(Types.SET_PAGINATION_INFO, paginationInfoAndType)
    let tasks = response.data.contents
    // 場合によっては表示件数がゼロになってしまうので、警告を出す。
    if (tasks.length === 0) {
      if (filter.filterName === i18n.tt('customTaskFilterAllSelect')) {
        // 同期を促すメッセージの表示を廃止 https://github.com/agri-info-design/connect-servers/issues/1112
        // Toast.i18nError('customErrorInitTasksNoTasks')
      } else {
        Toast.i18nError('customTaskFilterNoTasksError', { filtername: filter.filterName })
      }
    }
    commit(Types.LIST_TASKS_SUCCESS, tasks)
    commit(Types.CLEANUP_CURRENT_TASK)
    opts.onFinally()
  },

  showTaskDetail2({ commit }, params) {
    commit(Types.SET_CURRENT_TASK_WEATHER_INFO_FROM_OPEN_METEO, null)
    // 1. Taskに紐づくFieldのGeoJSONを取得
    const task = params.task
    let fieldGeoInfoKey = task.fieldItemKey
    if (UserInfo.isFSMigrated()) {
      fieldGeoInfoKey = task.fieldItemId
    }
    const allFields = store.getters.fields

    let fieldOfTask = null
    for (let i = 0; i < allFields.length; i++) {
      let f = allFields[i]
      if (UserInfo.isFSMigrated()) {
        // id = sessionId + documentId
        if (f.id === fieldGeoInfoKey) {
          fieldOfTask = f
        }
      } else {
        if (f.geoInfoKey === fieldGeoInfoKey) {
          fieldOfTask = f
        }
      }
    }
    if (fieldOfTask) {
      store.dispatch('setFieldDetail2', fieldOfTask)
      store.dispatch('growGetWeatherInfoOfField', { field: fieldOfTask, dateTime: task.startTime })
    }

    // 2. TaskのGeoJSON取得
    if (UserInfo.isFSMigrated()) {
      connectDatastoreClient
        .getTaskInfo(task)
        .then(response => {
          const apiResponse = {
            response: response,
            task: task,
            fieldOfTask: fieldOfTask,
            params: params,
          }
          store.dispatch('afterShowTaskDetail2', apiResponse)
        })
        .catch(error => {
          console.error(error)
          router.push({
            name: 'TaskDetailError',
          })
        })
    } else {
      connectNaviClient
        .getTaskInfo(task)
        .then(response => {
          const apiResponse = {
            response: response,
            task: task,
            fieldOfTask: fieldOfTask,
            params: params,
          }
          store.dispatch('afterShowTaskDetail2', apiResponse)
        })
        .catch(error => {
          console.error(error)
          router.push({
            name: 'TaskDetailError',
          })
        })
    }
  },
  afterShowTaskDetail2({ commit }, apiResponse) {
    const response = apiResponse.response
    const task = apiResponse.task
    const fieldOfTask = apiResponse.fieldOfTask
    const params = apiResponse.params

    const polygonGeoJson = JSON.parse(response.data.geoJson)
    const effectiveSpeed = response.data.effectiveSpeed
    let altitudes = []
    let maxAltitude = 0
    let minAltitude = 0

    let speeds = []
    let maxSpeed = 0
    let minSpeed = 0
    let pointAllFeature = turf.multiPoint([[0, 0, 0]])

    let gnssNumOfSatellites = []
    let maxGnssNumOfSatellites = 0
    let minGnssNumOfSatellites = 0

    let gnssStatus = []
    let maxGnssStatus = 0
    let minGnssStatus = 0

    let guidanceErrors = []
    let maxGuidanceErrors = 0
    let minGuidanceErrors = 0

    let guidanceHeadingErrors = []
    let maxGuidanceHeadingErrors = 0
    let minGuidanceHeadingErrors = 0

    let slants = []
    let maxSlant = 0
    let minSlant = 0

    let taskPolygons = new TaskPolygons()

    // GeoJson解析
    turf.featureEach(polygonGeoJson, function(currentFeature, currentIndex) {
      let currentProperties = currentFeature.properties
      let propName = currentProperties.name
      //console.log(propName)
      if (propName === Constants.GeoJsonProp.POINTS_ALL_ALTITUDES) {
        // 高さチャート描画用
        altitudes = currentProperties.values
        maxAltitude = currentProperties.max
        minAltitude = currentProperties.min
      } else if (propName.indexOf(Constants.GeoJsonProp.POLYGON_ALTITUDE_PREFIX) !== -1) {
        // 高さポリゴン
        const layerIndex = propName.slice(-1)
        const color = Constants.TRACK_COLORS[layerIndex]
        currentFeature.properties.color = color
        currentFeature.properties.layerIndex = layerIndex
        Geo.add0Point(currentFeature.geometry.coordinates)
        taskPolygons.altitudesPolygon.features.push(currentFeature)
      } else if (propName === Constants.GeoJsonProp.POINTS_ALL_SPEEDS) {
        // スピードチャート描画用
        speeds = currentProperties.values
        maxSpeed = currentProperties.max
        minSpeed = currentProperties.min
      } else if (propName.indexOf(Constants.GeoJsonProp.POLYGON_SPEED_PREFIX) !== -1) {
        // スピードポリゴン
        const layerIndex = propName.slice(-1)
        const color = Constants.TRACK_COLORS[layerIndex]
        currentFeature.properties.color = color
        currentFeature.properties.layerIndex = layerIndex
        Geo.add0Point(currentFeature.geometry.coordinates)
        taskPolygons.speedsPolygon.features.push(currentFeature)
      } else if (propName === Constants.GeoJsonProp.POINTS_ALL_GNSS_NUM_OF_SATELLITES) {
        // 測位衛星数チャート描画用
        gnssNumOfSatellites = currentProperties.values
        maxGnssNumOfSatellites = currentProperties.max
        minGnssNumOfSatellites = currentProperties.min
      } else if (propName.indexOf(Constants.GeoJsonProp.POLYGON_GNSS_NUM_OF_SATELLITES_PREFIX) !== -1) {
        // 測位衛星数ポリゴン
        const layerIndex = propName.slice(-1)
        const color = Constants.TRACK_COLORS[layerIndex]
        currentFeature.properties.color = color
        currentFeature.properties.layerIndex = layerIndex
        Geo.add0Point(currentFeature.geometry.coordinates)
        taskPolygons.gnssNumOfSatellitesPolygon.features.push(currentFeature)
      } else if (propName === Constants.GeoJsonProp.POINTS_ALL_GNSS_STATUS) {
        // GNSS状態チャート描画用
        gnssStatus = currentProperties.values
        maxGnssStatus = currentProperties.max
        minGnssStatus = currentProperties.min
      } else if (propName.indexOf(Constants.GeoJsonProp.POLYGON_GNSS_STATUS_PREFIX) !== -1) {
        // GNSS状態ポリゴン
        const layerIndex = propName.slice(-1)
        const color = Constants.TRACK_COLORS[layerIndex]
        currentFeature.properties.color = color
        currentFeature.properties.layerIndex = layerIndex
        Geo.add0Point(currentFeature.geometry.coordinates)
        taskPolygons.gnssStatusPolygon.features.push(currentFeature)
      } else if (propName === Constants.GeoJsonProp.POINTS_ALL_GUIDANCE_ERROR) {
        // 左右ずれチャート描画用
        guidanceErrors = currentProperties.values
        maxGuidanceErrors = currentProperties.max
        minGuidanceErrors = currentProperties.min
      } else if (propName.indexOf(Constants.GeoJsonProp.POLYGON_GUIDANCE_ERROR_PREFIX) !== -1) {
        // 左右ずれポリゴン
        const layerIndex = propName.slice(-1)
        const color = Constants.TRACK_COLORS[layerIndex]
        currentFeature.properties.color = color
        currentFeature.properties.layerIndex = layerIndex
        Geo.add0Point(currentFeature.geometry.coordinates)
        taskPolygons.guidanceErrorsPolygon.features.push(currentFeature)
      } else if (propName === Constants.GeoJsonProp.POINTS_ALL_GUIDANCE_HEADING_ERROR) {
        // 方位ずれチャート描画用
        guidanceHeadingErrors = currentProperties.values
        maxGuidanceHeadingErrors = currentProperties.max
        minGuidanceHeadingErrors = currentProperties.min
      } else if (propName.indexOf(Constants.GeoJsonProp.POLYGON_GUIDANCE_HEADING_ERROR_PREFIX) !== -1) {
        // 方位ずれポリゴン
        const layerIndex = propName.slice(-1)
        const color = Constants.TRACK_COLORS[layerIndex]
        currentFeature.properties.color = color
        currentFeature.properties.layerIndex = layerIndex
        Geo.add0Point(currentFeature.geometry.coordinates)
        taskPolygons.guidanceHeadingErrorsPolygon.features.push(currentFeature)
      } else if (propName === Constants.GeoJsonProp.POINTS_ALL_SLANT) {
        // 傾斜度チャート描画用
        slants = currentProperties.values
        maxSlant = currentProperties.max
        minSlant = currentProperties.min
      } else if (propName.indexOf(Constants.GeoJsonProp.POLYGON_SLANT_PREFIX) !== -1) {
        // 傾斜度ポリゴン
        const layerIndex = propName.slice(-1)
        const color = Constants.TRACK_COLORS[layerIndex]
        currentFeature.properties.color = color
        currentFeature.properties.layerIndex = layerIndex
        Geo.add0Point(currentFeature.geometry.coordinates)
        taskPolygons.slantsPolygon.features.push(currentFeature)
      } else if (propName === Constants.GeoJsonProp.POINT_ALL) {
        // 軌跡全ての座標
        pointAllFeature = currentFeature
      } else if (propName === Constants.GeoJsonProp.POLYGON_ALL) {
        // 軌跡全てのポリゴン
        taskPolygons.allPolygon.features.push(currentFeature)
        taskPolygons.allPolygon.features.forEach(feature => {
          const color = Constants.TRACK_FILL_COLOR
          const layerIndex = 1
          feature.properties.color = color
          feature.properties.layerIndex = layerIndex
          Geo.add0Point(currentFeature.geometry.coordinates)
        })
      } else if (propName.indexOf(Constants.GeoJsonProp.POLYGON_FILL_COLOR_PREFIX) !== -1) {
        // 塗りつぶしの色別ポリゴン
        const layerIndex = propName.slice(-1)
        const color = Constants.TRACK_COLOR_CODED_FILL_COLORS[layerIndex]
        currentFeature.properties.color = color
        currentFeature.properties.layerIndex = layerIndex
        Geo.add0Point(currentFeature.geometry.coordinates)
        taskPolygons.colorCodedFillPolygon.features.push(currentFeature)
      }
    })

    commit(Types.SHOW_TASK_DETAIL, {
      task,
      polygonGeoJson,
      altitudes,
      maxAltitude,
      minAltitude,
      speeds,
      maxSpeed,
      minSpeed,
      gnssNumOfSatellites,
      maxGnssNumOfSatellites,
      minGnssNumOfSatellites,
      gnssStatus,
      maxGnssStatus,
      minGnssStatus,
      guidanceErrors,
      maxGuidanceErrors,
      minGuidanceErrors,
      guidanceHeadingErrors,
      maxGuidanceHeadingErrors,
      minGuidanceHeadingErrors,
      slants,
      maxSlant,
      minSlant,
      pointAllFeature,
      effectiveSpeed,
      taskPolygons,
    })

    if (!fieldOfTask) {
      // Taskに紐づく圃場がない場合は、MapCenterを算出しておく
      const centerPoint = turf.center(pointAllFeature)
      commit(Types.SET_MAP_CENTER, centerPoint.geometry.coordinates)
    }

    let showTaskDetailParams = null

    if (params.taskDetailShowAction === Constants.SHOW_TASK_DETAIL_FROM_DIRECT) {
      showTaskDetailParams = {
        key: task.id,
        lastModifiedDateTime: task.lastModifiedDateTime,
      }
    } else {
      showTaskDetailParams = {
        key: task.id,
      }
    }

    router.push({
      name: params.nextPageName,
      params: showTaskDetailParams,
    })
  },

  updateTaskMetaData({ commit }, updateRequest) {
    if (UserInfo.isFSMigrated()) {
      connectDatastoreClient
        .updateTaskMetaData(updateRequest)
        .then(response => {
          const params = {
            response: response,
            id: updateRequest.task.id,
            syncedAt: updateRequest.task.syncedAt,
            updateRequest: updateRequest,
            nextFunction: 'afterUpdateTaskMetaData',
          }
          store.dispatch('waitSyncAsUpdateTask', params)
        })
        .catch(error => {
          console.error(error)
          updateRequest.onFailure()
        })
    } else {
      connectNaviClient
        .updateTaskMetaData(updateRequest)
        .then(response => {
          const apiResponse = {
            response: response,
            updateRequest: updateRequest,
          }
          store.dispatch('afterUpdateTaskMetaData', apiResponse)
        })
        .catch(error => {
          console.error(error)
          updateRequest.onFailure()
        })
    }
  },
  afterUpdateTaskMetaData({ commit }, apiResponse) {
    const response = apiResponse.response
    const updateRequest = apiResponse.updateRequest
    const updatedTask = response.data
    commit(Types.SET_CURRENT_TASK, updatedTask)
    updateRequest.onSuccess(updatedTask)
  },

  bulkDeleteTask({ commit }, task) {
    if (UserInfo.isFSMigrated()) {
      connectDatastoreClient
        .deleteTaskRecordItem(task)
        .then(response => {
          //params.onSuccess()
        })
        .catch(error => {
          console.error(error)
          updateRequest.onFailure()
        })
    } else {
      connectNaviClient
        .deleteTaskRecordItem(task.geoInfoKey)
        .then(response => {})
        .catch(error => {
          console.error(error)
          updateRequest.onFailure()
        })
    }
  },

  deleteTaskRecordItem({ commit }, updateRequest) {
    const task = updateRequest.task
    if (UserInfo.isFSMigrated()) {
      connectDatastoreClient
        .deleteTaskRecordItem(task)
        .then(response => {
          const request = {
            id: updateRequest.task.id,
            syncedAt: updateRequest.task.syncedAt,
            onSuccess: updateRequest.onSuccess,
            onFailure: updateRequest.onFailure,
            updateRequest: updateRequest,
            nextFunction: 'afterDeleteTaskRecordItem',
          }
          store.dispatch('waitSyncAsUpdateTask', request)
          //params.onSuccess()
        })
        .catch(error => {
          console.error(error)
          updateRequest.onFailure()
        })
    } else {
      connectNaviClient
        .deleteTaskRecordItem(task.geoInfoKey)
        .then(response => {
          const apiResponse = {
            updateRequest: updateRequest,
          }
          store.dispatch('afterDeleteTaskRecordItem', apiResponse)
        })
        .catch(error => {
          console.error(error)
          updateRequest.onFailure()
        })
    }
  },
  afterDeleteTaskRecordItem({ commit }, apiResponse) {
    const updateRequest = apiResponse.updateRequest
    updateRequest.onSuccess()
  },

  waitSyncAsUpdateTask({ commit }, params) {
    const request = {
      id: params.id,
      syncedAt: params.syncedAt,
      onSuccess: params.updateRequest.onSuccess,
      onFailure: params.updateRequest.onFailure,
    }
    let apiCallCount = 0
    let intervalId = setInterval(function() {
      connectDatastoreClient
        .waitSyncAsUpdateTaskMetaData(request)
        .then(response => {
          if (response.data.isCompleted) {
            clearInterval(intervalId)

            const apiResponse = {
              response: { data: response.data.remoteTaskRecordItem },
              updateRequest: params.updateRequest,
            }
            store.dispatch(params.nextFunction, apiResponse)
          }
        })
        .catch(error => {
          console.error(error)
          request.onFailure()
          clearInterval(intervalId)
        })
      apiCallCount++
      if (apiCallCount > Constants.SYNC_WAIT_LIMIT_COUNT) {
        console.error('WaitSyncAsUpdateTask API Call Limit!!')
        params.updateRequest.onFailure()
        clearInterval(intervalId)
      }
    }, Constants.SYNC_WAIT_API_CALL_INTERVAL)
  },

  showTaskDetailFromDirect({ commit }, opts) {
    if (UserInfo.isFSMigrated()) {
      connectDatastoreClient
        .getTaskRecordItem(opts)
        .then(response => {
          const apiResponse = {
            response: response,
            opts: opts,
          }
          store.dispatch('afterShowTaskDetailFromDirect', apiResponse)
        })
        .catch(error => {
          console.error(error)
          router.push({
            name: 'TaskDetailError',
          })
        })
    } else {
      connectNaviClient
        .getTaskRecordItem(opts)
        .then(response => {
          const apiResponse = {
            response: response,
            opts: opts,
          }
          store.dispatch('afterShowTaskDetailFromDirect', apiResponse)
        })
        .catch(error => {
          console.error(error)
          router.push({
            name: 'TaskDetailError',
          })
        })
    }
  },
  afterShowTaskDetailFromDirect({ commit }, apiResponse) {
    const response = apiResponse.response
    const opts = apiResponse.opts
    const task = response.data
    const params = {
      task: task,
      nextPageName: 'TaskDetailDirect',
      taskDetailShowAction: opts.taskDetailShowAction,
    }
    store.dispatch('showTaskDetail2', params)
  },

  /***************************
   * RefLineItems
   ***************************/
  initRefLines({ commit }) {
    const pagingOptions = store.getters.pagingOptions.refLines
    if (UserInfo.isFSMigrated()) {
      connectDatastoreClient.listRefLines(pagingOptions).then(response => {
        const apiResponse = {
          response: response,
        }
        store.dispatch('afterInitRefLines', apiResponse)
      })
    } else {
      connectNaviClient.listRefLines(pagingOptions).then(response => {
        const apiResponse = {
          response: response,
        }
        store.dispatch('afterInitRefLines', apiResponse)
      })
    }
  },
  afterInitRefLines({ commit }, apiResponse) {
    const response = apiResponse.response
    const paginationInfoAndType = {
      type: Constants.REFLINES_PAGINATION_INFO_TYPE,
      info: response.data.paginationInfo,
    }
    commit(Types.SET_PAGINATION_INFO, paginationInfoAndType)
    commit(Types.SET_REFLINES, response.data.contents)
  },

  showRefLineDetail({ commit }, refLine) {
    if (UserInfo.isFSMigrated()) {
      // datastoreの場合はrefLineにすでにgeojsonが含まれている
      // 直線で2点のはずでも3点以上ある場合もあるので、同じ点は使わない処理をバックエンドにで行う
      connectDatastoreClient
        .getRefLineGeoJson(refLine)
        .then(response => {
          const apiResponse = {
            response: response,
            refLine: refLine,
          }
          store.dispatch('afterShowRefLineDetail', apiResponse)
        })
        .catch(error => {
          console.error(error)
          if (error.response) {
            const responseData = error.response.data
            if (responseData) {
              Toast.error(responseData.message)
            }
          } else {
            Toast.i18nError('customNotAvailable')
          }
        })
    } else {
      connectNaviClient
        .getRefLineGeoJson(refLine)
        .then(response => {
          const apiResponse = {
            response: response,
            refLine: refLine,
          }
          store.dispatch('afterShowRefLineDetail', apiResponse)
        })
        .catch(error => {
          console.error(error)
          if (error.response) {
            const responseData = error.response.data
            if (responseData) {
              Toast.error(responseData.message)
            }
          } else {
            Toast.i18nError('customNotAvailable')
          }
        })
    }
  },
  afterShowRefLineDetail({ commit }, apiResponse) {
    const response = apiResponse.response
    const refLine = apiResponse.refLine
    const item = { item: refLine, geoJson: response.data }
    commit(Types.SET_CURRENT_REFLINE, item)
    router.push({
      name: 'RefLineDetail',
      params: {
        key: refLine.id,
      },
    })
  },
  updateRefLineMetaData({ commit }, updateRequest) {
    if (UserInfo.isFSMigrated()) {
      connectDatastoreClient
        .updateRefLineMetaData(updateRequest)
        .then(response => {
          const params = {
            response: response,
            id: updateRequest.refLine.id,
            syncedAt: updateRequest.refLine.syncedAt,
            updateRequest: updateRequest,
            nextFunction: 'afterUpdateRefLineMetaData',
          }
          store.dispatch('waitSyncAsUpdateRefLine', params)
        })
        .catch(error => {
          console.error(error)
          updateRequest.onFailure()
        })
    } else {
      connectNaviClient
        .updateRefLineMetaData(updateRequest)
        .then(response => {
          const apiResponse = {
            response: response,
            updateRequest: updateRequest,
          }
          store.dispatch('afterUpdateRefLineMetaData', apiResponse)
        })
        .catch(error => {
          console.error(error)
          updateRequest.onFailure()
        })
    }
  },
  afterUpdateRefLineMetaData({ commit }, apiResponse) {
    const response = apiResponse.response
    const updateRequest = apiResponse.updateRequest
    const item = { item: response.data, geoJson: updateRequest.geoJson }
    commit(Types.SET_CURRENT_REFLINE, item)
    updateRequest.onSuccess()
  },

  deleteRefLine({ commit }, updateRequest) {
    const refLine = updateRequest.refLine
    if (UserInfo.isFSMigrated()) {
      connectDatastoreClient
        .deleteRefLine(refLine)
        .then(response => {
          const request = {
            id: updateRequest.refLine.id,
            syncedAt: updateRequest.refLine.syncedAt,
            onSuccess: updateRequest.onSuccess,
            onFailure: updateRequest.onFailure,
            updateRequest: updateRequest,
            nextFunction: 'afterDeleteRefLine',
          }
          store.dispatch('waitSyncAsUpdateRefLine', request)
        })
        .catch(error => {
          Toast.i18nError('customRefLineDeleteError')
          updateRequest.onFailure()
          console.error(error)
        })
    } else {
      connectNaviClient
        .deleteRefLine(refLine)
        .then(response => {
          const apiResponse = {
            updateRequest: updateRequest,
          }
          store.dispatch('afterDeleteRefLine', apiResponse)
        })
        .catch(error => {
          Toast.i18nError('customRefLineDeleteError')
          updateRequest.onFailure()
          console.error(error)
        })
    }
  },
  afterDeleteRefLine({ commit }, apiResponse) {
    const updateRequest = apiResponse.updateRequest
    updateRequest.onSuccess()
  },

  waitSyncAsUpdateRefLine({ commit }, params) {
    const request = {
      id: params.id,
      syncedAt: params.syncedAt,
      onSuccess: params.updateRequest.onSuccess,
      onFailure: params.updateRequest.onFailure,
    }
    let apiCallCount = 0
    let intervalId = setInterval(function() {
      connectDatastoreClient
        .waitSyncAsUpdateRefLineMetaData(request)
        .then(response => {
          if (response.data.isCompleted) {
            clearInterval(intervalId)
            const apiResponse = {
              response: { data: response.data.remoteRefLineItem },
              updateRequest: params.updateRequest,
            }
            store.dispatch(params.nextFunction, apiResponse)
          }
        })
        .catch(error => {
          console.error(error)
          request.onFailure()
          clearInterval(intervalId)
        })
      apiCallCount++
      if (apiCallCount > Constants.SYNC_WAIT_LIMIT_COUNT) {
        console.error('WaitSyncAsUpdateRefLine API Call Limit!!')
        params.updateRequest.onFailure()
        clearInterval(intervalId)
      }
    }, Constants.SYNC_WAIT_API_CALL_INTERVAL)
  },

  importRefLines({ commit }, request) {
    if (UserInfo.isFSMigrated()) {
      connectDatastoreClient
        .importRefLines(request)
        .then(response => {
          const apiResponse = {
            count: response.data.importResults.filter(rs => rs.success).length,
            failedCount: response.data.importResults.filter(rs => !rs.success).length,
          }
          store.dispatch('afterImportRefLines', apiResponse)
        })
        .catch(error => {
          console.error(error)
          Toast.i18nError('customRefLineImportErrorMessage')
        })
    } else {
      connectNaviClient
        .importRefLines(request)
        .then(response => {
          const apiResponse = {
            count: response.data.count,
          }
          store.dispatch('afterImportRefLines', apiResponse)
        })
        .catch(error => {
          console.error(error)
          Toast.i18nError('customRefLineImportErrorMessage')
        })
    }
  },
  afterImportRefLines({ commit }, apiResponse) {
    if (apiResponse.count > 0) {
      emitFeedEvent('refline_added', 'Import x' + apiResponse.count)
    }
    Toast.i18nSuccess('customRefLineImportFinishedMessage', {
      count: apiResponse.count,
    })
    store.dispatch('initRefLines')
  },

  /***************************
   * UploadGeoFile
   ***************************/
  uploadGeoFile({ commit }, request) {
    const file = request.geoFile
    const params = {
      encoding: request.encoding,
    }
    if (UserInfo.isFSMigrated()) {
      connectDatastoreClient
        .uploadGeoFile(file, params)
        .then(response => {
          const apiResponse = {
            response: response,
            request: request,
          }
          store.dispatch('afterUploadGeoFile', apiResponse)
        })
        .catch(error => {
          const responseData = error.response.data
          console.error(responseData)
          commit(Types.FIELD_IMPORT_HIDE_MAP, true)
          if (responseData.code === Constants.APIErrorCode.MULTIPOLYGON_IMPORT_ERROR) {
            Toast.i18nError('customMultiPolygonImportError')
          } else {
            Toast.i18nError('customFieldUploadErrorMessage')
          }
        })
    } else {
      connectNaviClient
        .uploadGeoFile(file, params)
        .then(response => {
          const apiResponse = {
            response: response,
            request: request,
          }
          store.dispatch('afterUploadGeoFile', apiResponse)
        })
        .catch(error => {
          const responseData = error.response.data
          console.error(responseData)
          commit(Types.FIELD_IMPORT_HIDE_MAP, true)
          if (responseData.code === Constants.APIErrorCode.MULTIPOLYGON_IMPORT_ERROR) {
            Toast.i18nError('customMultiPolygonImportError')
          } else {
            Toast.i18nError('customFieldUploadErrorMessage')
          }
        })
    }
  },
  afterUploadGeoFile({ commit }, apiResponse) {
    const response = apiResponse.response
    const request = apiResponse.request

    let importedGeoJson = response.data
    let importFeatures = request.importFeatures
    let propertyKeys = request.geoFilePropertyKeys
    let geoFileInfo = request.geoFileInfo
    let googleMap = request.googleMap

    commit(Types.FIELD_IMPORT_HIDE_MAP, false)

    // google map
    googleMap.$mapPromise.then(map => {
      map.setTilt(0)

      for (let i = 0; i < importedGeoJson.features.length; i++) {
        const feature = importedGeoJson.features[i]
        feature.properties[FieldImport.GEOJSON_PROPERTY_FIELD_ENABLED] = FieldImport.YES
        feature.properties[FieldImport.GEOJSON_PROPERTY_FIELD_ID] = i
        importFeatures.push(feature)
        let center = []
        const coordinates = feature.geometry.coordinates
        if (request.mode === Constants.IMPORT_MODE.FIELDS) {
          center = polylabel(coordinates, 1.0)
        } else {
          // reflineはstartpointにマーカーを立てる
          const startPoint = coordinates[0]
          center.push(startPoint[0])
          center.push(startPoint[1])
        }

        const marker = {
          import: true,
          id: feature.properties[FieldImport.GEOJSON_PROPERTY_FIELD_ID],
          position: { lat: center[1], lng: center[0] },
        }
        request.markers.push(marker)

        for (let prop in feature.properties) {
          if (!propertyKeys.includes(prop)) {
            if (!FieldImport.canIgnoreGeoJsonProperty(prop)) {
              propertyKeys.push(prop)
            }
          }
        }
      }
      map.data.addGeoJson(importedGeoJson)
      let bounds = new google.maps.LatLngBounds()
      map.data.forEach(feature => {
        feature.getGeometry().forEachLatLng(latlng => {
          bounds.extend(latlng)
        })
      })
      map.data.addListener('click', function(event) {
        request.showInfoWindow(event)
      })

      let strokeWeight = 2
      if (request.mode === Constants.IMPORT_MODE.REFLINES) {
        strokeWeight = 4
      }
      map.data.setStyle(feature => {
        const isFieldImport = feature.getProperty(FieldImport.GEOJSON_PROPERTY_FIELD_ENABLED)
        if (isFieldImport === FieldImport.YES) {
          return {
            strokeColor: Constants.FIELD_CURRENT_LINE_COLOR,
            fillColor: Constants.FIELD_FILL_COLOR,
            fillOpacity: Constants.FIELD_FILL_OPACITY,
            strokeWeight: strokeWeight,
          }
        } else {
          return {
            strokeColor: FieldImport.FIELD_DISABLED_FILL_COLOR,
            fillColor: FieldImport.FIELD_DISABLED_FILL_COLOR,
            fillOpacity: Constants.FIELD_FILL_OPACITY,
            strokeWeight: strokeWeight,
          }
        }
      })
      geoFileInfo.count = importFeatures.length
      map.fitBounds(bounds)
    })
  },

  /***************************
   * Observations
   ***************************/

  // PF
  listPfObservations({ commit }) {
    if (UserInfo.isFSMigrated()) {
      connectDatastoreClient
        .listPfObservations()
        .then(response => {
          const apiResponse = {
            response: response,
          }
          store.dispatch('afterListPfObservations', apiResponse)
        })
        .catch(error => console.error(error))
    } else {
      connectNaviClient
        .listPfObservations()
        .then(response => {
          const apiResponse = {
            response: response,
          }
          store.dispatch('afterListPfObservations', apiResponse)
        })
        .catch(error => console.error(error))
    }
  },
  afterListPfObservations({ commit }, apiResponse) {
    const response = apiResponse.response
    const observations = response.data
    commit(Types.SET_PF_OBSERVATIONS, observations)
    for (let i = 0; i < observations.length; i++) {
      const o = observations[i]
      if (ApplicationConfig.OPEN_METEO_ENABLED) {
        store.dispatch('growGetSoilMoistureFromOpenMeteo', o)
      }
    }
  },

  createPfObservation({ commit }, params) {
    if (UserInfo.isFSMigrated()) {
      connectDatastoreClient
        .createPfObservation(params.request)
        .then(response => {
          const apiResponse = {
            params: params,
          }
          store.dispatch('afterCreatePfObservation', apiResponse)
        })
        .catch(error => {
          console.error()
          params.onFailure()
        })
    } else {
      connectNaviClient
        .createPfObservation(params.request)
        .then(response => {
          const apiResponse = {
            params: params,
          }
          store.dispatch('afterCreatePfObservation', apiResponse)
        })
        .catch(error => {
          console.error()
          params.onFailure()
        })
    }
  },
  afterCreatePfObservation({ commit }, apiResponse) {
    const params = apiResponse.params
    store.dispatch('listPfObservations')
    params.onSuccess()
  },

  updatePfObservation({ commit }, params) {
    if (UserInfo.isFSMigrated()) {
      connectDatastoreClient
        .updatePfObservation(params.request)
        .then(response => {
          const apiResponse = {
            params: params,
          }
          store.dispatch('afterUpdatePfObservation', apiResponse)
        })
        .catch(error => {
          console.error()
          params.onFailure()
        })
    } else {
      connectNaviClient
        .updatePfObservation(params.request)
        .then(response => {
          const apiResponse = {
            params: params,
          }
          store.dispatch('afterUpdatePfObservation', apiResponse)
        })
        .catch(error => {
          console.error()
          params.onFailure()
        })
    }
  },
  afterUpdatePfObservation({ commit }, apiResponse) {
    const params = apiResponse.params
    store.dispatch('listPfObservations')
    params.onSuccess()
  },

  deletePfObservation({ commit }, params) {
    if (UserInfo.isFSMigrated()) {
      connectDatastoreClient
        .deletePfObservation(params.request)
        .then(response => {
          const apiResponse = {
            params: params,
          }
          store.dispatch('afterDeletePfObservation', apiResponse)
        })
        .catch(error => {
          console.error()
          params.onFailure()
        })
    } else {
      connectNaviClient
        .deletePfObservation(params.request)
        .then(response => {
          const apiResponse = {
            params: params,
          }
          store.dispatch('afterDeletePfObservation', apiResponse)
        })
        .catch(error => {
          console.error()
          params.onFailure()
        })
    }
  },
  afterDeletePfObservation({ commit }, apiResponse) {
    const params = apiResponse.params
    store.dispatch('listPfObservations')
    params.onSuccess()
  },

  // AT
  listAtObservations({ commit }) {
    if (UserInfo.isFSMigrated()) {
      connectDatastoreClient
        .listAtObservations()
        .then(response => {
          const apiResponse = {
            response: response,
          }
          store.dispatch('afterListAtObservations', apiResponse)
        })
        .catch(error => console.error(error))
    } else {
      connectNaviClient
        .listAtObservations()
        .then(response => {
          const apiResponse = {
            response: response,
          }
          store.dispatch('afterListAtObservations', apiResponse)
        })
        .catch(error => console.error(error))
    }
  },
  afterListAtObservations({ commit }, apiResponse) {
    const response = apiResponse.response
    const observations = response.data
    commit(Types.SET_AT_OBSERVATIONS, observations)
    // AT値をGrowServerに取得
    for (let i = 0; i < observations.length; i++) {
      const o = observations[i]
      if (ApplicationConfig.OPEN_METEO_ENABLED) {
        store.dispatch('growGetAtFromOpenMeteo', o)
      }
    }
  },

  createAtObservation({ commit }, params) {
    if (UserInfo.isFSMigrated()) {
      connectDatastoreClient
        .createAtObservation(params.request)
        .then(response => {
          const apiResponse = {
            params: params,
          }
          store.dispatch('afterCreateAtObservation', apiResponse)
        })
        .catch(error => {
          console.error()
          params.onFailure()
        })
    } else {
      connectNaviClient
        .createAtObservation(params.request)
        .then(response => {
          const apiResponse = {
            params: params,
          }
          store.dispatch('afterCreateAtObservation', apiResponse)
        })
        .catch(error => {
          console.error()
          params.onFailure()
        })
    }
  },
  afterCreateAtObservation({ commit }, apiResponse) {
    const params = apiResponse.params
    store.dispatch('listAtObservations')
    params.onSuccess()
  },

  updateAtObservation({ commit }, params) {
    if (UserInfo.isFSMigrated()) {
      connectDatastoreClient
        .updateAtObservation(params.request)
        .then(response => {
          const apiResponse = {
            params: params,
          }
          store.dispatch('afterCreateAtObservation', apiResponse)
        })
        .catch(error => {
          console.error()
          params.onFailure()
        })
    } else {
      connectNaviClient
        .updateAtObservation(params.request)
        .then(response => {
          const apiResponse = {
            params: params,
          }
          store.dispatch('afterCreateAtObservation', apiResponse)
        })
        .catch(error => {
          console.error()
          params.onFailure()
        })
    }
  },
  afterUpdateAtObservation({ commit }, apiResponse) {
    const params = apiResponse.params
    store.dispatch('listAtObservations')
    params.onSuccess()
  },

  deleteAtObservation({ commit }, params) {
    if (UserInfo.isFSMigrated()) {
      connectDatastoreClient
        .deleteAtObservation(params.request)
        .then(response => {
          const apiResponse = {
            params: params,
          }
          store.dispatch('afeterDeleteAtObservation', apiResponse)
        })
        .catch(error => {
          console.error()
          params.onFailure()
        })
    } else {
      connectNaviClient
        .deleteAtObservation(params.request)
        .then(response => {
          const apiResponse = {
            params: params,
          }
          store.dispatch('afeterDeleteAtObservation', apiResponse)
        })
        .catch(error => {
          console.error()
          params.onFailure()
        })
    }
  },
  afeterDeleteAtObservation({ commit }, apiResponse) {
    const params = apiResponse.params
    store.dispatch('listAtObservations')
    params.onSuccess()
  },

  /***************************
   * Plantings
   ***************************/
  initPlantings({ commit }) {
    if (UserInfo.isFSMigrated()) {
      connectDatastoreClient.listPlantings().then(response => {
        const apiResponse = {
          response: response,
        }
        store.dispatch('afterInitPlantings', apiResponse)
      })
    } else {
      connectNaviClient.listPlantings().then(response => {
        const apiResponse = {
          response: response,
        }
        store.dispatch('afterInitPlantings', apiResponse)
      })
    }
  },
  afterInitPlantings({ commit }, apiResponse) {
    const response = apiResponse.response
    const plantings = response.data
    commit(Types.SET_PLANTINGS, plantings)
  },

  createPlanting({ commit }, params) {
    if (UserInfo.isFSMigrated()) {
      connectDatastoreClient.createPlanting(params.request).then(response => {
        if (params.onSuccess) {
          const apiResponse = {
            response: response,
            params: params,
          }
          store.dispatch('afterCreatePlanting', apiResponse)
        }
      })
    } else {
      connectNaviClient.createPlanting(params.request).then(response => {
        if (params.onSuccess) {
          const apiResponse = {
            response: response,
            params: params,
          }
          store.dispatch('afterCreatePlanting', apiResponse)
        }
      })
    }
  },
  afterCreatePlanting({ commit }, apiResponse) {
    const response = apiResponse.response
    const params = apiResponse.params
    params.onSuccess(response.data)
  },

  updatePlanting({ commit }, params) {
    if (UserInfo.isFSMigrated()) {
      connectDatastoreClient.updatePlanting(params.request).then(response => {
        if (params.onSuccess) {
          const apiResponse = {
            response: response,
            params: params,
          }
          store.dispatch('afterUpdatePlanting', apiResponse)
        }
      })
    } else {
      connectNaviClient.updatePlanting(params.request).then(response => {
        if (params.onSuccess) {
          const apiResponse = {
            response: response,
            params: params,
          }
          store.dispatch('afterUpdatePlanting', apiResponse)
        }
      })
    }
  },
  afterUpdatePlanting({ commit }, apiResponse) {
    const response = apiResponse.response
    const params = apiResponse.params
    params.onSuccess(response.data)
  },

  deletePlanting({ commit }, params) {
    if (UserInfo.isFSMigrated()) {
      connectDatastoreClient.deletePlanting(params.request).then(response => {
        if (params.onSuccess) {
          const apiResponse = {
            response: response,
            params: params,
          }
          store.dispatch('afterDeletePlanting', apiResponse)
        }
      })
    } else {
      connectNaviClient.deletePlanting(params.request).then(response => {
        if (params.onSuccess) {
          const apiResponse = {
            response: response,
            params: params,
          }
          store.dispatch('afterDeletePlanting', apiResponse)
        }
      })
    }
  },
  afterDeletePlanting({ commit }, apiResponse) {
    const response = apiResponse.response
    const params = apiResponse.params
    params.onSuccess(response.data)
  },

  /***************************
   * 高低差マップ
   ***************************/
  /**
   * 高低差マップ取得
   */
  getFieldElevationMap({ commit }, params) {
    const field = params.field
    if (UserInfo.isFSMigrated()) {
      connectDatastoreClient
        .getFieldElevationMap(field)
        .then(response => {
          const apiResponse = {
            response: response,
            params: params,
          }
          store.dispatch('afterGetFieldElevationMap', apiResponse)
        })
        .catch(error => {
          if (error.response.status === 404) {
            commit(Types.CLEANUP_CURRENT_FILED_ELEVATION_MAP)
          } else {
            console.error(error)
          }
        })
    } else {
      connectNaviClient
        .getFieldElevationMap(field)
        .then(response => {
          const apiResponse = {
            response: response,
            params: params,
          }
          store.dispatch('afterGetFieldElevationMap', apiResponse)
        })
        .catch(error => {
          if (error.status === 404) {
            commit(Types.CLEANUP_CURRENT_FILED_ELEVATION_MAP)
          } else {
            console.error(error)
          }
        })
    }
  },
  afterGetFieldElevationMap({ commit }, apiResponse) {
    const response = apiResponse.response
    const params = apiResponse.params
    const map = response.data
    commit(Types.SET_CURRENT_FIELD_ELEVATION_MAP, map)
    const onSuccess = params.onSuccess
    if (onSuccess) {
      onSuccess()
    }
  },

  /**
   * 高低差マップ作成
   */
  createFieldElevationMap({ commit }, params) {
    // statusをCreatingにしておく
    let map = { status: 'Creating' }
    commit(Types.SET_CURRENT_FIELD_ELEVATION_MAP, map)

    if (UserInfo.isFSMigrated()) {
      connectDatastoreClient
        .createFieldElevationMap(params)
        .then(response => {
          const apiResponse = {
            response: response,
            params: params,
          }
          store.dispatch('afterCreateFieldElevationMap', apiResponse)
        })
        .catch(error => {
          const onFailure = params.onFailure
          if (onFailure) {
            onFailure(error)
          }
          console.error(error)
        })
    } else {
      connectNaviClient
        .createFieldElevationMap(params)
        .then(response => {
          const apiResponse = {
            response: response,
            params: params,
          }
          store.dispatch('afterCreateFieldElevationMap', apiResponse)
        })
        .catch(error => {
          const onFailure = params.onFailure
          if (onFailure) {
            onFailure(error)
          }
          console.error(error)
        })
    }
  },
  afterCreateFieldElevationMap({ commit }, apiResponse) {
    const response = apiResponse.response
    const params = apiResponse.params
    let map = response.data
    commit(Types.SET_CURRENT_FIELD_ELEVATION_MAP, map)
    const onSuccess = params.onSuccess
    if (onSuccess) {
      onSuccess()
    }
  },

  /***************************
   * OperationType
   ***************************/
  listOperationAvailableTypes({ commit }) {
    if (UserInfo.isFSMigrated()) {
      connectDatastoreClient.listOperationAvailableTypes().then(response => {
        const apiResponse = {
          response: response,
        }
        store.dispatch('afterListOperationAvailableTypes', apiResponse)
      })
    } else {
      connectNaviClient.listOperationAvailableTypes().then(response => {
        const apiResponse = {
          response: response,
        }
        store.dispatch('afterListOperationAvailableTypes', apiResponse)
      })
    }
  },
  afterListOperationAvailableTypes({ commit }, apiResponse) {
    const response = apiResponse.response
    commit(Types.SET_AVAILABLE_OPERATION_TYPES, response.data)
  },
  setTasks({ commit }, tasks) {
    commit(Types.LIST_TASKS_SUCCESS, tasks)
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
